/* TT-PRESS-KIT — the image viewer.

   Josh, 2026-08-21: "Having the images as individual downloads with open full
   size. I don't know. That's just kinda weird. I feel like we need a better
   gallery view."

   So a tile opens a viewer rather than the raw file, and "Open full size" lives
   inside it — one considered action instead of a link repeated under every
   thumbnail. Arrows, Escape and the arrow keys, because that is what the rest
   of this site's overlays do and a journalist should not have to learn a second
   set of manners on one page.

   THE TILES ARE THE SOURCE OF TRUTH. Every full-size URL and caption is read
   off the buttons Liquid already rendered, so there is no second list in a
   script to keep in step with the one on the page — the failure mode that made
   the PDP's review thumbnails open the wrong photograph. */
(function () {
  'use strict';

  function boot() {
    var grid = document.querySelector('[data-pk-gallery]');
    var lb = document.querySelector('[data-pk-lb]');
    if (!grid || !lb) return;
    if (grid.ttPk) return;
    grid.ttPk = true;

    var tiles = [].slice.call(grid.querySelectorAll('[data-pk-open]'));
    if (!tiles.length) return;

    var img = lb.querySelector('[data-pk-img]');
    var cap = lb.querySelector('[data-pk-lbcap]');
    var count = lb.querySelector('[data-pk-count]');
    var dl = lb.querySelector('[data-pk-dl]');
    var i = 0;
    var opener = null;

    function show(n) {
      i = (n + tiles.length) % tiles.length;
      var t = tiles[i];
      var full = t.getAttribute('data-pk-full');
      img.setAttribute('src', full);
      img.setAttribute('alt', t.getAttribute('data-pk-cap') || '');
      cap.textContent = t.getAttribute('data-pk-cap') || '';
      count.textContent = (i + 1) + ' / ' + tiles.length;
      dl.setAttribute('href', full);
    }

    function open(n, from) {
      opener = from || null;
      show(n);
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = lb.querySelector('[data-pk-close]');
      if (x && x.focus) x.focus();
    }

    function shut() {
      if (lb.hidden) return;
      lb.hidden = true;
      document.body.style.overflow = '';
      if (opener && opener.focus) opener.focus();
      opener = null;
    }

    grid.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-pk-open]');
      if (!t) return;
      open(tiles.indexOf(t), t);
    });

    lb.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pk-close]')) return shut();
      if (ev.target.closest('[data-pk-prev]')) return show(i - 1);
      if (ev.target.closest('[data-pk-next]')) return show(i + 1);
    });

    document.addEventListener('keydown', function (ev) {
      if (lb.hidden) return;
      if (ev.key === 'Escape') return shut();
      if (ev.key === 'ArrowRight') return show(i + 1);
      if (ev.key === 'ArrowLeft') return show(i - 1);
    });
  }

  /* ---- DOWNLOAD ALL ------------------------------------------------------
     A zip, written in the browser, out of the URLs the gallery already names.

     WHY NOT A PREPARED FILE. The alternative is somebody exporting a zip and
     uploading it to Shopify Files, which is manual work (CLAUDE.md: build the
     path instead) and, worse, a second copy of the gallery that goes stale the
     first time a photograph is added. This cannot: it reads the same tiles the
     grid was built from, so the download IS the gallery by construction.

     STORED, NOT DEFLATED. A zip entry may be stored uncompressed, and these are
     JPEGs — already compressed, so deflate would spend time to save almost
     nothing, and implementing it would mean shipping an inflate/deflate. The
     format below is the documented minimum: a local header per file, a central
     directory, and an end-of-central-directory record.

     NO ZIP64. Zip64 starts to matter past 4GB or 65535 entries; this is twenty
     photographs. The guard below refuses rather than writing a file that would
     silently truncate. */

  var CRC = (function () {
    var t = new Int32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
      t[n] = c;
    }
    return function (buf) {
      var c = -1;
      for (var i = 0; i < buf.length; i++) c = (c >>> 8) ^ t[(c ^ buf[i]) & 0xFF];
      return (c ^ -1) >>> 0;
    };
  })();

  /* DOS time is 1980-based and this writes a fixed stamp on purpose. The real
     mtime of a CDN fetch is meaningless, and a fixed one makes two runs of the
     same gallery produce byte-identical archives. */
  var DOS_TIME = 0, DOS_DATE = 33;

  function ascii(s) {
    /* ZIP FILENAMES ARE BYTES. A non-ASCII character would need the UTF-8 flag
       and a matching byte length; the names here are built from product titles,
       so anything outside ASCII is transliterated away rather than writing a
       length that disagrees with the bytes. */
    var out = [];
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      out.push(c > 31 && c < 127 ? c : 95);
    }
    return new Uint8Array(out);
  }

  function zip(files) {
    var chunks = [], central = [], offset = 0;
    var u16 = function (v) { return [v & 0xFF, (v >>> 8) & 0xFF]; };
    var u32 = function (v) { return [v & 0xFF, (v >>> 8) & 0xFF, (v >>> 16) & 0xFF, (v >>> 24) & 0xFF]; };

    files.forEach(function (f) {
      var name = ascii(f.name);
      var crc = CRC(f.data);
      var head = [].concat(
        [0x50, 0x4B, 0x03, 0x04], u16(20), u16(0), u16(0),
        u16(DOS_TIME), u16(DOS_DATE), u32(crc), u32(f.data.length), u32(f.data.length),
        u16(name.length), u16(0));
      chunks.push(new Uint8Array(head), name, f.data);

      central.push([].concat(
        [0x50, 0x4B, 0x01, 0x02], u16(20), u16(20), u16(0), u16(0),
        u16(DOS_TIME), u16(DOS_DATE), u32(crc), u32(f.data.length), u32(f.data.length),
        u16(name.length), u16(0), u16(0), u16(0), u16(0), u32(0), u32(offset),
        Array.prototype.slice.call(name)));

      offset += head.length + name.length + f.data.length;
    });

    var dir = [];
    central.forEach(function (c) { dir = dir.concat(c); });
    var end = [].concat(
      [0x50, 0x4B, 0x05, 0x06], u16(0), u16(0),
      u16(files.length), u16(files.length), u32(dir.length), u32(offset), u16(0));

    chunks.push(new Uint8Array(dir), new Uint8Array(end));
    return new Blob(chunks, { type: 'application/zip' });
  }

  function bootDownloadAll() {
    var btn = document.querySelector('[data-pk-dlall]');
    if (!btn || btn.ttPk) return;
    if (!window.Blob || !window.URL || !window.fetch || !window.Uint8Array) return;
    btn.ttPk = true;

    var label = btn.querySelector('[data-pk-dlall-label]');
    var hint = document.querySelector('[data-pk-dlall-hint]');
    var say = function (html) { if (label) label.innerHTML = html; };
    var rest = label ? label.innerHTML : 'Download all';

    /* SHOWN ONLY ONCE IT CAN WORK. It ships hidden and disabled so a dead script
       never leaves a button that does nothing. */
    btn.hidden = false;
    btn.disabled = false;
    if (hint) hint.hidden = true;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var tiles = [].slice.call(document.querySelectorAll('[data-pk-open]'));
      if (!tiles.length) return;
      if (tiles.length > 65535) { say('Too many images'); return; }

      btn.disabled = true;
      var used = {};
      var done = 0;

      var jobs = tiles.map(function (t, i) {
        var url = t.getAttribute('data-pk-full');
        var base = (t.getAttribute('data-pk-cap') || ('image-' + (i + 1)))
          .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || ('image-' + (i + 1));
        var ext = (url.split('?')[0].match(/\.(jpe?g|png|webp|gif|avif)$/i) || ['.jpg'])[0];
        /* A COLLECTION CAN SHOW ONE PRODUCT TWICE, and three shots of one
           product all share its title. Without this the archive would hold one
           file where the gallery shows three, silently. */
        var name = base + ext;
        var n = 1;
        while (used[name.toLowerCase()]) { n++; name = base + '-' + n + ext; }
        used[name.toLowerCase()] = true;

        return fetch(url, { mode: 'cors', credentials: 'omit' })
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.arrayBuffer(); })
          .then(function (b) {
            done++;
            say('Preparing… ' + done + '/' + tiles.length);
            return { name: name, data: new Uint8Array(b) };
          })
          /* ONE UNREACHABLE IMAGE MUST NOT LOSE THE OTHER NINETEEN. */
          .catch(function () { done++; say('Preparing… ' + done + '/' + tiles.length); return null; });
      });

      Promise.all(jobs).then(function (files) {
        var got = files.filter(Boolean);
        if (!got.length) { say('Could not fetch the images'); btn.disabled = false; return; }
        var url = URL.createObjectURL(zip(got));
        var a = document.createElement('a');
        a.href = url;
        a.download = (document.title || 'press-kit').toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.zip';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        /* Revoked on a later turn of the loop: revoking synchronously after
           click() races the browser's own read of the blob in some engines. */
        setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
        say(got.length < tiles.length ? (got.length + ' of ' + tiles.length + ' downloaded') : rest);
        btn.disabled = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      bootDownloadAll();
    });
  } else {
    boot();
    bootDownloadAll();
  }
  document.addEventListener('shopify:section:load', function () {
    boot();
    bootDownloadAll();
  });
})();
